


















































import {Vue, Component, Ref, Prop, PropSync} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {SelectWings} from "wings-ui-components";
import { CollapseTransition } from "vue2-transitions";
import {BlacklistItem} from "@/store/blacklists/types";
import {notifySuccess, notifyError} from "@/utils/notify-helper";
import { ActionLog } from '@/store/auth/types';
import { getTranslatedParams } from '@/utils/notify-utils';

@Component({components: {CollapseTransition,SelectWings}})
export default class ImportContacts extends Vue {
  @Ref('validator') validator: any;
  @PropSync('show') is_show!: boolean;
  @PropSync('blacklist_id') blacklistId!: number;
  @PropSync('contact_ids') contactIds: any;
  @Getter("blacklists") blackLists: any;
  @Getter("blacklistItem") blacklistItem: any;
  @Action("getBlacklists") actionGetBlacklists: any;
  @Action("copyBlackListContacts") actionCopyBlackListContacts: any;
  @Action("moveBlackListContacts") actionMoveBlackListContacts: any;
  @Action("deleteBlackListContact") actionDelete: any;
  @Action("actionLog") actionLog: any;

  logObject: ActionLog = {}

  private action = 'copy'
  private toGroup = null

  get toBlackList() {
    return this.blackLists.filter((item: BlacklistItem) => { return item.id != this.blacklistId })
  }

  get toBlackListItem() {
    return this.blackLists.find((item: BlacklistItem) => { return item.id == this.toGroup })
  }

  created() {
    try {
      this.actionGetBlacklists()
    } catch(error) {
      notifyError(error);
    }
  }

  async onClick() {
    try {
      const formData = {
        fromBlackListId: this.blacklistId,
        toBlackListId: this.toGroup,
        contactIds: this.contactIds,
      }

      let res = null
      let message = ''
      if (this.action == 'copy') {
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: "Contacts copying",
          actionStatus: 'success',
          objectType: "Contact",
          addititionalInfo: getTranslatedParams({
            contactsCopied: this.contactIds.length,
            fromBlackListId: this.blacklistItem?.name,
            toBlackListId: this.toBlackListItem?.name
          })
        }

        res = await this.actionCopyBlackListContacts(formData)
        message = this.$t('contacts.contacts_copied') + ' ' + res.data.contactCount
      }
      if (this.action == 'move') {
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: "Contacts moving",
          actionStatus: 'success',
          objectType: "Contact",
          addititionalInfo: getTranslatedParams({
            contactsMoved: this.contactIds.length,
            fromBlackListId: this.blacklistItem?.name,
            toBlackListId: this.toBlackListItem?.name
          })
        }

        res = await this.actionMoveBlackListContacts(formData)
        message = this.$t('contacts.contacts_moved') + ' ' + res.data.contactCount
        this.$emit('refresh')
      }
      if (this.action == 'delete') {
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: "Removal",
          actionStatus: 'success',
          objectType: "Contact",
          addititionalInfo: getTranslatedParams({number: this.contactIds.length, blackListId: this.blacklistItem?.name})
        }

        res = await this.actionDelete({
          params: {blackListId: this.blacklistId},
          data: {contactIds: this.contactIds}
        })
        message = this.$t('contacts.contacts_deleted').toString()
        this.$emit('refresh')
      }
      await this.actionLog(this.logObject)
      if (res.data?.mSISDNDuplicates?.length > 0) message += '<br>' + this.$t('contacts.mSISDNDuplicates') + ': ' + res.data.mSISDNDuplicates.join(', ')
      if (res.data?.emailDuplicates?.length > 0) message += '<br>' + this.$t('contacts.emailDuplicates') + ': ' + res.data.emailDuplicates.join(', ')
      notifySuccess(message);

    } catch(error) {
      notifyError(error)
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }

}
